import { c as _c } from "react/compiler-runtime";
import { useMediaQueryList } from "@hooks/use-media-query";
import { DEFAULT_BOLD_TEXT_FONT_WEIGHT, DEFAULT_INPUT_FONT_SIZE, DEFAULT_TEXT_FONT_WEIGHT } from "@styles/common-styles";
/**
 * Returns the common styling for account settings layout.
 * It has its own specific file as the design for account settings is different than other parts of the Dashboard
 */
export function useAccountSettingsLayout() {
  const $ = _c(3);
  const {
    isScreenSmOrSmaller
  } = useMediaQueryList();
  const accountSettingsFontSize = isScreenSmOrSmaller ? DEFAULT_INPUT_FONT_SIZE : "1.25rem";
  const accountSettingsFontWeight = isScreenSmOrSmaller ? DEFAULT_TEXT_FONT_WEIGHT : DEFAULT_BOLD_TEXT_FONT_WEIGHT;
  let t0;
  if ($[0] !== accountSettingsFontSize || $[1] !== accountSettingsFontWeight) {
    t0 = {
      accountSettingsFontSize,
      accountSettingsFontWeight
    };
    $[0] = accountSettingsFontSize;
    $[1] = accountSettingsFontWeight;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}